

import Joi from 'joi';
import { HOST } from "common-import/constants";
import { Request } from "common-import/helpers";
import * as Validator from "./Rating.Validator.js"

class RatingAPI {


  /*
  POST http://localhost:3000/rating/create
  Content-Type: application/json
  Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjQzMjYyMjA1OTF9.Fr46mr5322DQr4VVDM4ibBSDN5EFENCfhkRfG2P-O7Q

  {
      "subjectId":"15977258949",
      "subjectType":"project",
      "objectId":"190173675144",
      "objectType":"contractor",
      "content":"Nha thau tuyet voi",
      "star":5,
      "meta":{
          "images":["url1","url2"],
          "relationShip":"I hired this company",
          "projectPrice":"32.322.322",
          "projectDate":"90 days",
          "projectName":"Xây khách sạn HouseLink 2",
          "yourEmail":"trinhvietnambk@gmail.com"
      }
  }

  */

  create = async (data) => {
    const validator = Validator.VALIDATION_RATING_CREATE;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/rating/create", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


  /*

  POST http://localhost:3000/rating/update
  Content-Type: application/json
  Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjQzMjYyMjA1OTF9.Fr46mr5322DQr4VVDM4ibBSDN5EFENCfhkRfG2P-O7Q
  {
        "id":"662101169234",
        "content":"Nha thau tuyet voi update",
        "star":3,
        "meta":{
            "images":["url1","url2"],
            "relationShip":"I hired this company",
            "projectPrice":"32.322.322",
            "projectDate":"90 days",
            "projectName":"Xây khách sạn HouseLink 2",
            "yourEmail":"trinhvietnambk@gmail.com"
        }
  }

  */

  update = async (data) => {
    const validator = Validator.VALIDATION_RATING_UPDATE;
    if(validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/rating/update", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };


  /*
  POST http://localhost:3000/rating/delete
  Content-Type: application/json
  Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjQzMjYyMjA1OTF9.Fr46mr5322DQr4VVDM4ibBSDN5EFENCfhkRfG2P-O7Q

  {
       "id":"662101169234"
  }
  */

  delete = async (data) => {
    const validator = Validator.VALIDATION_RATING_DELETE;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/rating/delete", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

  /*
    POST http://api.houselink.com:3000/rating/list
    Content-Type: application/json
    Authorization: eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VySWQiOiIyNDQ1MjE5MDQyMTYiLCJjcmVhdGVkQXQiOjE1MjQzMjYyMjA1OTF9.Fr46mr5322DQr4VVDM4ibBSDN5EFENCfhkRfG2P-O7Q

    {
        "objectId":"783449412431"
    }
  * */
  list = async (data) => {
    const validator = Validator.VALIDATION_RATING_LIST;
    if (validator !== false && !!validator.body) {
      const result = Joi.validate(data, validator.body);
      if (result.error !== null) {
        return { validateError: result.error.details[0].message }
      }
    }
    let result = await Request.post(HOST + "/rating/list", data);
    if (Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  };

}
export default new RatingAPI();



// WEBPACK FOOTER //
// ./src/services/rating/Rating.API.js